<payee-popup
  [heading]="dialogData?.transition_label"
  [onCancel]="onCancel"
>
  <ng-template #payeePopupDescriptionTemplate>
    <div class="case-assigned-description">Kérlek, rögzítsd a négy számjegyből álló jelvényszámot.</div>
  </ng-template>

  <form
    [formGroup]="form"
    (ngSubmit)="$event.preventDefault()"
  >
    <payee-form-field width="max">
      <input
        payee-input
        type="text"
        inputmode="numeric"
        maxlength="4"
        autocomplete="off"
        placeholder="0123"
        formControlName="bailiff_information"
      />
      @if (bailiff_information.invalid && bailiff_information.dirty) {
        <ng-container payee-error>
          @if (bailiff_information.hasError("required")) {
            <span>Mező kitöltése kötelező!</span>
          }
          @if (bailiff_information.hasError("pattern")) {
            <span>Helytelen formátum. Elvárt: négy számjegy, pl. 0123.</span>
          }
        </ng-container>
      }
    </payee-form-field>
  </form>

  <ng-template #payeePopupSubmitTemplate>
    <button
      payee-button
      width="max"
      [disabled]="loading"
      [loading]="loading"
      (click)="submit()"
    >
      <div class="flex vcenter hcenter">
        <span>Rögzítés</span>
        <payee-icon
          height="10px"
          name="arrow-right-white"
        ></payee-icon>
      </div>
    </button>
  </ng-template>
</payee-popup>
